export enum AuthTokenType {
    AccessToken,
    RefreshToken
}
